import React from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';
import FetchService from 'general/js/services/fetch-service';
import ScoringLoader, { endpointNames } from 'general/js/loaders/scoring-loader';
import { BlockPlaceholder } from 'components/block-placeholder';
import { BlockSpinner } from 'components/block-spinner';
import HighlightsPanel from './highlights-panel';

class HighlightsPanelLayout extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: undefined,
        };

        const updateInSeconds = props.options.updateInSeconds || 60;
        const axiosConfig = {
            url: props.options.endpointUrl
        };

        this.fetchService = new FetchService(axiosConfig, updateInSeconds);
        this.cancelSubscribe = null;
    }

    componentDidMount() {
        ScoringLoader.subscribe(endpointNames.LIVE_SCANNER);
        this.updateData();
    }

    componentDidUpdate() {
        this.updateData();
    }

    componentWillUnmount() {
        ScoringLoader.unsubscribe(endpointNames.LIVE_SCANNER);
        this.cancelFecthData();
    }

    updateData() {
        const isVisible = get(this.props.liveScanner, 'liveComponents.liveText.show', false);
        const { context } = this.props.options;
        const isContextRight = (context === 'Live' || context === 'WOLive');

        if (isContextRight && !isVisible) {
            this.cancelFecthData();
        } else {
            this.fetchData();
        }
    }

    successFetch = (data) => {
        this.setState({ data });
    }

    fetchData() {
        if (this.cancelSubscribe) return;

        this.cancelSubscribe = this.fetchService.subscribe(this.successFetch);
    }

    cancelFecthData() {
        if (this.cancelSubscribe) {
            this.cancelSubscribe();
        }
    }

    render() {
        const { liveScanner } = this.props;
        const { context } = this.props.options;
        const isContextRight = (context === 'Live' || context === 'WOLive');
        const { data } = this.state;
        const config = get(liveScanner, 'liveComponents.liveText');

        if (!config) return null;

        if (isContextRight && !config.show) return null;

        if (data === undefined) {
            return (
                <BlockPlaceholder minHeight={300}>
                    <BlockSpinner />
                </BlockPlaceholder>
            );
        }

        return <HighlightsPanel model={data} />;
    }
}

const mapStateToProps = (state) => ({
    liveScanner: state.scoring[endpointNames.LIVE_SCANNER],
});

const HighlightsPanelLayoutContainer = connect(
    mapStateToProps,
    null
)(HighlightsPanelLayout);

export default HighlightsPanelLayoutContainer;
